<template lang="pug">
div(class="d-flex flex-column flex-grow-1 min-h-0 tw-h-full fill-height overflow-hidden")
  //Head
  div(class=" tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pb-1 tw-text-left")
    v-row
      v-col
        span(class="tw-text-2xl text-secondary tw-font-bold") {{ $t('Website.Common.chooseTheme') }}
  //Body
  div(class=" tw-flex tw-h-full tw-flex-row tw-flex-grow tw-p-4 mt-4 tw-pb-0 tw-pl-2 tw-overflow-hidden tw-overflow-y-auto")
    v-row(align-self="start" class=" tw-flex tw-flex-row tw-h-full tw-flex-grow tw-p-2 tw-pt-0 tw-pb-0 ")
      v-col(cols="12" class=" tw-h-full tw-w-full tw-max-w-full  tw-flex tw-flex-col tw-flex-grow  tw-py-0")
        v-row(align="start" justify="space-around")
          v-col(cols="12")
            v-row(aling="center" justify="space-around" class=" tw-h-full")
              v-col(cols="12" class="tw-flex-wrap")
                div(v-for="theme in themes" :key="theme.id" class="tw-w-1/2 tw-inline-block tw-px-2 pb-4")
                  kubiqa-website-options-theme-item(:theme="theme" @setTheme="setTheme")

  //Foot
  div(class="tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pt-1 ")
    v-row(justify="end" align-self="end" align="end" class="tw-bottom-0")
      v-col(cols="auto" align-end class="tw-h-full fill-height")
        v-btn(@click="$emit('close')" text :ripple="false")
          span(class=" tw-text-kPurple tw-mt-4") {{ $t('Common.cancel') }}
        v-btn(depressed color="rgba(94,129,244,0.80)" :loading="loading" @click="submit")
          span(class="tw-font-bold") {{ $t('Common.save') }}
</template>

<script>
export default {
  data() {
    return {
      theme: null,
      website: null,
      loading: false,
    };
  },
  mounted() {
    this.website = JSON.parse(JSON.stringify(this.$store.getters['website/website']));
    this.$store.dispatch('website/themes');
  },
  computed: {
    themes() {
      return this.$store.getters['website/themes'];
    },
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.error = true;
        this.error_message = 'error';
      }
    },
    setTheme(theme) {
      this.theme = theme;
    },
    submit() {
      this.loading = true;
      this.website.theme_id = this.theme;
      this.$store
        .dispatch('website/update', this.website)
        .then((response) => {
          this.$emit('close');
          this.$store.dispatch('website/setTheme', this.themes[this.theme].path);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
  },
};
</script>
